(function () {
    'use strict';

    angular
        .module('controlEditModule')
        .controller('ControlTestController', Controller);

    Controller.$inject = ['$scope', '$state', 'controlTest', 'testResults'];

    function Controller($scope, $state, controlTest, testResults) {

        $scope.controlTest = controlTest;
        $scope.testResults = testResults;
        $scope.isShowTestResults = showTestResults();

        // Show Test Results
        function showTestResults() {
            if (!$scope.controlTest.ControlTestID) return false;
            if (!_.isObject($scope.govProcess) || _.isUndefined($scope.govProcess.GovernanceProcessID)) return true;

            return !!testResults;
        }

        // Observation
        $scope.goToObservations = function () {
            $state.go('control.controlTests.edit.observations');
        }
    }
})();